/*成本库 */
import { $http, buildHeaders } from "./index";

//获取列表
export const costitem_page = (params) => {
  return $http.get("/admin/CostItem/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const costitem_detail = (id) => {
  return $http.get("/admin/CostItem/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const costitem_add = (data) => {
  return $http.post("/admin/CostItem/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const costitem_edit = (data) => {
  return $http.post("/admin/CostItem/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};


//修改状态
export const costitem_updateStatus = (data) => {
  return $http.post("/admin/CostItem/updateStatus", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const costitem_delete = (id) => {
  return $http.post(
    "/admin/CostItem/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};
